module.exports = __webpack_public_path__ + "static/media/under-maintenance.632b5bea.svg";